<app-page-header
  title="Häufig gestellte Fragen"
  subtitle="Antworten auf die wichtigsten Themen rund um Coins, Bestellungen und dein Kundenkonto."
  icon="help_outline"
  variant="gradient">
</app-page-header>

<div class="nlc-container nlc-faq-wrapper nlc-slide-up">
  <mat-accordion class="nlc-faq-accordion" multi>
    <ng-container *ngIf="faqs$ | async as faqs">
      <mat-expansion-panel *ngFor="let faq of faqs" class="nlc-faq-panel nlc-card">
        <mat-expansion-panel-header class="nlc-faq-header" expandIconPosition="end">
          <mat-panel-title>
            <div class="nlc-faq-header-content">
              <div class="nlc-faq-icon">
                <mat-icon>help_outline</mat-icon>
              </div>
              <div class="nlc-faq-text">
                <span class="nlc-faq-question">{{ faq.question }}</span>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="nlc-faq-answer" [innerHTML]="faq.answer"></div>
      </mat-expansion-panel>
    </ng-container>
  </mat-accordion>
</div>
